import { PickupRequestReason } from "../types";

// A reasonId that isn't in the reasons list yet (backend added a new one before this app
// refetched it, or the request references a retired reason) must not surface the raw id.
const resolveReasonNames = (
  reasonIds: number[],
  reasons: PickupRequestReason[],
  unknownLabel: string
): string[] =>
  reasonIds.map((reasonId) => {
    const reason = reasons.find((item) => item.reasonId === reasonId);

    return reason ? reason.reasonName : unknownLabel;
  });

export default resolveReasonNames;
